import React, { HTMLProps } from 'react';
import * as CSS from 'csstype';
import { cx } from '@emotion/css';
import { PublicComponentProps } from './types';

export interface FlexBoxProps extends HTMLProps<HTMLDivElement>, PublicComponentProps {
  alignContent?: CSS.AlignContentProperty;
  alignItems?: CSS.AlignItemsProperty;
  alignSelf?: CSS.AlignSelfProperty;
  flexBasis?: CSS.FlexBasisProperty<string | number>;
  flexDirection?: CSS.FlexDirectionProperty;
  flexFlow?: CSS.FlexFlowProperty;
  flexWrap?: CSS.FlexWrapProperty;
  justifyContent?: CSS.JustifyContentProperty;
}

export const FlexBox = ({
  style,
  children,
  alignContent,
  alignItems = 'center',
  alignSelf,
  flexBasis,
  justifyContent = 'space-between',
  flexDirection,
  flexFlow,
  flexWrap,
  className,
  ...restProps
}: FlexBoxProps) => {
  const flexBoxStyles = {
    display: 'flex',
    alignContent,
    alignItems,
    alignSelf,
    flexBasis,
    flexDirection,
    flexFlow,
    flexWrap,
    justifyContent,
  };

  return (
    <div className={cx('crc-flexbox', className)} style={{ ...flexBoxStyles, ...style }} {...restProps}>
      {children}
    </div>
  );
};
